import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import { LanguageProvider, useLanguage } from './context/LanguageContext';
import { AdProvider } from './context/AdContext';

import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import AdBanner from './components/layout/AdBanner';

import Home from './pages/Home';
import Search from './pages/Search';
import ListingDetail from './pages/ListingDetail';
import CreateListing from './pages/CreateListing';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import MyListings from './pages/MyListings';
import EditListing from './pages/EditListing';
import Admin from './pages/Admin';

function AppLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        {/* Üst yatay reklam bandı */}
        <div className="max-w-5xl mx-auto px-6 pt-4">
          <AdBanner position="top" />
        </div>

        <div className="flex items-start justify-center">
          {/* Sol reklam alanı */}
          <aside className="hidden xl:flex xl:flex-col w-44 shrink-0 self-stretch pl-4 pt-6">
            <AdBanner position="left" />
            <AdBanner position="left-full" />
          </aside>

          {/* Ana içerik */}
          <div className="flex-1 min-w-0">
            {children}
          </div>

          {/* Sağ reklam alanı */}
          <aside className="hidden xl:flex xl:flex-col w-44 shrink-0 self-stretch pr-4 pt-6">
            <AdBanner position="right" />
            <AdBanner position="right-full" />
          </aside>
        </div>

        {/* Alt yatay reklam bandı */}
        <div className="max-w-5xl mx-auto px-6 pb-6">
          <AdBanner position="bottom" />
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
      <AuthProvider>
        <NotificationProvider>
        <AdProvider>
          <AppLayout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/search" element={<Search />} />
              <Route path="/listing/:id" element={<ListingDetail />} />
              <Route path="/create" element={<CreateListing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/profile/:id" element={<Profile />} />
              <Route path="/my-listings" element={<MyListings />} />
              <Route path="/edit/:id" element={<EditListing />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </AppLayout>
        </AdProvider>
        </NotificationProvider>
      </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

function NotFoundPage() {
  const { t } = useLanguage();
  return (
    <div className="max-w-xl mx-auto px-4 py-20 text-center">
      <p className="text-6xl mb-6">🔍</p>
      <h2 className="text-3xl font-bold text-apple-gray-dark mb-3">{t('not_found.title')}</h2>
      <p className="text-apple-gray-mid mb-8">{t('not_found.subtitle')}</p>
      <a href="/" className="btn-primary">{t('not_found.home')}</a>
    </div>
  );
}
